import { Routes } from '@angular/router';

import { mpsCoreRoutes } from './mps-core.routes';
import { mpsAuthRoutes } from './mps-auth.routes';

export const mpsRoutes: Routes = [...mpsCoreRoutes, ...mpsAuthRoutes];
